import {
  assemblePlanNameDisplay,
  autocompleteReady,
  contactsForSelect,
  notifyError,
  notifySuccess,
  notifyWarning,
  objectBy,
  objectById
} from './utils'
import {OK} from 'http-status-codes'
import Constants from './constants'
import _ from 'lodash'

function createOrEdit(statePath) {
  let path = 'jobs/edit'
  if (!statePath) {
    return path
  }
  if (statePath === 'create') {
    path = 'jobs/create'
  }
  if (statePath === 'supplyProCreate') {
    path = 'supplyPro/job/ptracJob'
  }
  return path
}

export function jobSetCommunity(self, community, statePath) {
  if (!community) {
    return
  }

  const clientId = self.$store.get(`${createOrEdit(statePath)}@clientId`)
  const builderId = self.$store.get(`${createOrEdit(statePath)}@builderId`)

  if (!Array.isArray(community.clientIds)) {
    community.clientIds = []
  }

  if (!Array.isArray(community.builderIds)) {
    community.builderIds = []
  }

  self.selectedCommunity = community
  self.$store.set(`${createOrEdit(statePath)}@community`, { id: community.id, name: community.name })

  communityExistsButNotAssociated(self, community, clientId, builderId)
}

export function communityExistsButNotAssociated(self, community, clientId, builderId) {
  if (!clientId && !builderId) {
    return
  }

  if (!Array.isArray(community.clientIds)) {
    community.clientIds = []
  }

  if (!Array.isArray(community.builderIds)) {
    community.builderIds = []
  }

  if (!community.clientIds.includes(clientId) && !community.builderIds.includes(builderId)) {
    const data = {
      community
    }
    if (clientId) {
      data.client = {
        id: clientId,
        name: self.selectedClient.name
      }
    }
    if (builderId) {
      data.builder = {
        id: builderId,
        name: self.selectedBuilder.name
      }
    }
    self.$eventHub.$emit('show-modal-4', 'Community Exists', data, '500px')
  }
}

export function jobSetCompany(self, company) {
  if (self.newCompany.builder) {
    self.setBuilder(company)
  } else if (self.newCompany.client) {
    self.setClient(company)
  }
}

export function jobNoCompanySelected(self, type) {
  if (type === Constants.COMPANY.TYPES.CLIENT) {
    self.selectedClient = { id: null, name: null }
  }
  if (type === Constants.COMPANY.TYPES.BUILDER) {
    self.selectedBuilder = { id: null, name: null }
  }
  self.newCompany.builder = false
  self.newCompany.client = false
}

export async function jobFindClients(self, text, cb, statePath) {
  self.$store.set(`${createOrEdit(statePath)}@clientId`, null)

  const response = await self.findCompany(text, Constants.COMPANY.TYPES.CLIENT)
  if (response && OK === response.status && response.data.length > 0) {
    cb(self.autocompleteClients)
  }
}

export async function jobFindBuilders(self, text, cb, statePath) {
  self.$store.set(`${createOrEdit(statePath)}@builderId`, null)

  const response = await self.findCompany(text, Constants.COMPANY.TYPES.BUILDER)
  if (response && OK === response.status && response.data.length > 0) {
    cb(self.autocompleteBuilders)
  }
}

export async function jobMaybeLoadClient(self, statePath) {
  const clientId = self.$store.get(`${createOrEdit(statePath)}@clientId`)
  if (clientId) {
    const response = await self.$store.dispatch('fetchById', {
      endpoint: Constants.ENTITY_ENDPOINTS.COMPANIES,
      id: clientId
    })
    if (OK === response.status) {
      self.isClientResult = true
      self.selectedClient = response.data
      self.clientContacts = contactsForSelect(response.data.contacts, self.$store.get('jobs/edit@clientContactId'))
      self.$store.commit('companies/autocompleteResultsClient', response.data)
    }
    return
  }

  self.selectedClient = { id: null, name: null }
}

export async function jobMaybeLoadBuilder(self, statePath) {
  const builderId = self.$store.get(`${createOrEdit(statePath)}@builderId`)
  if (builderId) {
    const response = await self.$store.dispatch('fetchById', {
      endpoint: Constants.ENTITY_ENDPOINTS.COMPANIES,
      id: builderId
    })
    if (OK === response.status) {
      self.isBuilderResult = true
      self.selectedBuilder = response.data
      self.builderContacts = contactsForSelect(response.data.contacts, self.$store.get('jobs/edit@builderContactId'))
      self.$store.commit('companies/autocompleteResultsBuilder', response.data)
    }
    return
  }

  self.selectedBuilder = { id: null, name: null }
}

export function jobSetClient(self, client, statePath) {
  if (!client) {
    return
  }

  self.isClientResult = true
  self.selectedClient = client

  if (client.pwsNumber) {
    self.selectedClient.name += `${self.selectedClient.name} (${client.pwsNumber})`
  }

  self.$store.set(`${createOrEdit(statePath)}@clientId`, client.id)
  self.clientContacts = contactsForSelect(client.contacts)
  if (client.contacts.length === 1) {
    self.$store.set(`${createOrEdit(statePath)}@clientContactId`, client.contacts[0].id)
  }
  self.$store.commit('companies/autocompleteResultsClient', [])

  if (_.get(client, 'quickBooksPreferences.onHold')) {
    self.onHoldWarning = true
    self.$validator.errors.add({
      field: 'clientId',
      msg: 'WARNING: ' + client.name + '\'s account is On Hold'
    })
  }

  self.newCompany.client = false
}

export function jobSetBuilder(self, builder, statePath) {
  if (builder) {
    self.isBuilderResult = true
    self.selectedBuilder = builder
    self.$store.set(`${createOrEdit(statePath)}@builderId`, builder.id)
    self.builderContacts = contactsForSelect(builder.contacts)
    if (builder.contacts.length === 1) {
      self.$store.set(`${createOrEdit(statePath)}@builderContactId`, builder.contacts[0].id)
    }
    self.$store.commit('companies/autocompleteResultsBuilder', [])
    self.newCompany.builder = false
  }
}

export async function jobFindPlanNames(self, text, cb, statePath) {
  self.$store.set(`${createOrEdit(statePath)}@planNameId`, null)
  const builderId = self.$store.get(`${createOrEdit(statePath)}@builderId`)

  if (builderId && self.verifyBuilderSelected() && autocompleteReady(text)) {
    const payload = {
      name: text,
      number: text,
      builderId: builderId
    }

    await self.$store.dispatch('planNames/fetchByNameOrNumberAndBuilderId', payload)
    const planNames = self.$store.getters['planNames/resultsDisplay']

    if (planNames && planNames.length > 0) {
      cb(planNames)
    } else {
      self.$refs.planNameId.$refs.suggestions.showPopper = false // closes autocomplete results

      const plan = {
        name: self.selectedPlanName,
        active: true,
        builderId: builderId
      }

      self.$eventHub.$emit('show-modal-4', 'No Plan Name Results Found', plan, '500px')
    }
  }
}

export function jobSetPlanName(self, planName, statePath) {
  if (planName) {
    if (!planName.plan) {
      planName.plan = assemblePlanNameDisplay(planName)
    }
    self.selectedPlanName = planName.plan
    self.$store.set(`${createOrEdit(statePath)}@planNameId`, planName.id)
    self.$store.commit('planNames/resetResults')
  }
}

export function jobEditPlanName(self, statePath) {
  if (self.$store.get(`${createOrEdit(statePath)}@planNameId`)) {
    self.$eventHub.$emit('show-modal-3', 'Plan Name', {id: self.$store.get(`${createOrEdit(statePath)}@planNameId`)}, '500px')
  }
}

export function jobAddPlanName(self, statePath) {
  if (self.verifyBuilderSelected()) {
    const plan = {
      active: true,
      builderId: self.$store.get(`${createOrEdit(statePath)}@builderId`)
    }

    self.$eventHub.$emit('show-modal-4', 'Plan Name', plan, '600px')
  }
}

export async function jobFetchPlanNamePDF(self, statePath) {
  if (self.selectedPlanName && self.$store.get(`${createOrEdit(statePath)}@planNameId`)) {
    const response = await self.$store.dispatch('fetchById', {
      endpoint: 'plan-names',
      id: self.$store.get(`${createOrEdit(statePath)}@planNameId`)
    })

    if (OK === response.status && response.data.fileId) {
      const fileResponse = await self.$store.dispatch('fetchById', {
        endpoint: 'files',
        id: response.data.fileId
      })

      if (OK === fileResponse.status && fileResponse.data.name) {
        self.planNamePDF = fileResponse.data.name
        return
      }
    }
    self.planNamePDF = null
  }
}

export async function jobGenerateJobNumber(self, statePath) {
  const response = await self.$store.dispatch('jobs/fetchJobNumberSequenceAndReturn')
  if (OK === response.status && _.get(response.data, 'next')) {
    self.$store.set(`${createOrEdit(statePath)}@number`, response.data.next)
  }
}

export async function jobCopyClientToBuilder(self, statePath) {
  const clientId = self.$store.get(`${createOrEdit(statePath)}@clientId`)
  const response = await self.$store.dispatch('fetchById', { endpoint: 'companies', id: clientId })
  if (OK === response.status) {
    const client = response.data
    if (client.types.includes(Constants.COMPANY_TYPES.BUILDER)) {
      self.builderContacts = []
      self.$store.set(`${createOrEdit(statePath)}@builderId`, null)
      self.$store.set(`${createOrEdit(statePath)}@builderContactId`, null)
      self.setBuilder(client)
      if (self.$store.get(`${createOrEdit(statePath)}@clientContactId`)) {
        self.$store.set(`${createOrEdit(statePath)}@builderContactId`, self.$store.get(`${createOrEdit(statePath)}@clientContactId`))
      }
      return
    }

    notifyWarning(self, `${client.name} is not a builder`)
  }
}

export async function jobAddClientContact(self, statePath) {
  self.isAddClientContact = true
  self.isAddBuilderContact = false
  await jobHydrateCompany(self, self.$store.get(`${createOrEdit(statePath)}@clientId`))
  self.$eventHub.$emit('show-modal-4', 'Company Contact', null, '800px')
}

export async function jobEditClientContact(self, statePath) {
  await jobHydrateCompany(self, self.$store.get(`${createOrEdit(statePath)}@clientId`))
  const contactId = self.$store.get(`${createOrEdit(statePath)}@clientContactId`)
  const contact = objectById(self.contacts, contactId)
  self.$eventHub.$emit('show-modal-4', 'Company Contact', contact, '800px')
}

export async function jobAddBuilderContact(self, statePath) {
  self.isAddBuilderContact = true
  self.isAddClientContact = false
  await jobHydrateCompany(self, self.$store.get(`${createOrEdit(statePath)}@builderId`))
  self.$eventHub.$emit('show-modal-4', 'Company Contact', null, '800px')
}

export async function jobEditBuilderContact(self, statePath) {
  await jobHydrateCompany(self, self.$store.get(`${createOrEdit(statePath)}@builderId`))
  const contactId = self.$store.get(`${createOrEdit(statePath)}@builderContactId`)
  const contact = objectById(self.contacts, contactId)
  self.$eventHub.$emit('show-modal-4', 'Company Contact', contact, '800px')
}

export function jobVerifyBuilderSelected(self, statePath) {
  if (!self.$store.get(`${createOrEdit(statePath)}@builderId`)) {
    self.$eventHub.$emit('show-modal-4', 'No Builder', null, '500px')
    return false
  }
  return true
}

export function jobVerifyClientOrBuilderSelected(self, statePath) {
  if (!self.$store.get(`${createOrEdit(statePath)}@builderId`) && !self.$store.get(`${createOrEdit(statePath)}@clientId`)) {
    const data = {
      message: 'No client or builder has been selected for this job. Please select a client or builder to proceed.'
    }
    self.$eventHub.$emit('show-modal-5', 'No Client Or Builder', data, '500px')
    return false
  }
  return true
}

export function jobWarnWhenCompletedOrCancelled(self, jobStatus, hasPendingInvoice=false) {
  let message
  if (jobStatus === Constants.STATUSES.COMPLETED) {
    message = `<strong>WARNING</strong>: Setting the job status to <i>Completed</i> will also Complete all Tasks associated with this Job.<br><br>`
  }
  if (jobStatus === Constants.STATUSES.CANCELLED) {
    message = `<strong>WARNING</strong>: Setting the job status to <i>Cancelled</i> will also Cancel all uncompleted Tasks associated with this Job.<br><br>`
    if (hasPendingInvoice) {
      message += `<strong>There is a PENDING Invoice Submittal task that will be CANCELLED</strong>.<br><br>`
    }
  }
  message += "Are you sure you want to proceed?"
  self.$eventHub.$emit(
    'show-modal-2',
    'Verify Job Status Change',
    { initialStatus: self.initialJobStatus, message: message },
    '500px')
}

export function jobMaybeLoadCoordinator(self, statePath) {
  const coordinatorId = self.$store.get(`${createOrEdit(statePath)}@coordinatorId`)
  if (coordinatorId) {
    const coordinator = self.$store.get('users/byId', coordinatorId)
    self.selectedCoordinator = _.get(coordinator, 'name')
  }
}

export function jobFindCoordinators(self, text, cb, statePath) {
  self.$store.set(`${createOrEdit(statePath)}@coordinatorId`, null)
  cb(self.$store.getters['users/findByNameStartsWith'](text))
}

export function jobSetCoordinator(self, coordinator, statePath) {
  if (coordinator) {
    self.selectedCoordinator = coordinator.name
    self.$store.set(`${createOrEdit(statePath)}@coordinatorId`, coordinator.id)
  }
}

export async function jobCopyBuilderToClient(self, statePath) {
  const builderId = self.$store.get(`${createOrEdit(statePath)}@builderId`)
  const response = await self.$store.dispatch('fetchById', { endpoint: 'companies', id: builderId })
  if (OK === response.status) {
    const builder = response.data
    if (builder.types.includes(Constants.COMPANY_TYPES.CLIENT)) {
      self.clientContacts = []
      self.$store.set(`${createOrEdit(statePath)}@clientId`, null)
      self.$store.set(`${createOrEdit(statePath)}@clientContactId`, null)
      self.setClient(builder)
      if (self.$store.get(`${createOrEdit(statePath)}@builderContactId`)) {
        self.$store.set(`${createOrEdit(statePath)}@clientContactId`, self.$store.get(`${createOrEdit(statePath)}@builderContactId`))
      }
      return
    }
    notifyWarning(self, `${builder.name} is not a client`)
  }
}

export async function jobHydrateCompany(self, companyId) {
  const response = await self.$store.dispatch('fetchById', {
    endpoint: 'companies',
    id: companyId
  })
  if (OK === response.status) {
    self.$store.set('companies/hydrateEdit', response.data)
  }
}

export async function jobFetchTravelCharge(self) {
  const response = await self.$store.dispatch('jobs/fetchTravelCharge')
  if (OK === response.status) {
    self.travelCharge.value = response.data.travelCharge
    self.travelCharge.state = response.data.travelChargeState
  }
}

export async function jobIfJobNumberExistsThenWarn(self) {
  const response = await self.$store.dispatch('jobs/fetchJobNumberExists')
  if (OK === response.status && response.data) {
    notifyWarning(self, 'The selected job number is in use. If this is intentional, duplicate job numbers are allowed.')
  }
}

export async function confirmDeleteJob(self, job) {
  let message = ''
  let showButton = false
  self.toDelete = job.id

  const response = await self.$store.dispatch('tasks/fetchTasksByJobId', self.toDelete)

  if (OK !== response.status) {
    notifyError(self, 'Unable to fetch tasks for Job. Delete cancelled.')
    return
  }

  const taskList = response.data
  const taskStatuses = []

  taskList.forEach(task => {
    if (task.status === Constants.STATUSES.COMPLETED) {
      taskStatuses.push(task.status)
    }
  })

  // Only allows power users to delete if all tasks complete or if no tasks complete. Other groups delete based on permissions canEdit.
  if (taskStatuses.length === 1 && self.$store.get('security/isInGroup', Constants.GROUPS.POWER_USERS)) {
    message = 'You can not delete <strong>' + job.name + '</strong> because one task in the job has been completed.'
    showButton = false
    self.showConfirmDelete(job, message, showButton)
    return
  }

  message = 'Are you sure you want to delete <strong>' + job.name + '</strong>? This will completely remove the job and its associated tasks and comments.',

  // happy path - Job can be deleted
  showButton = true
  self.showConfirmDelete(job, message, showButton)
}

export async function refreshJobs(self, job) {
  const response = await self.$store.dispatch('jobs/fetchByProjectId', job.projectId)
  if (OK === response.status) {
    notifySuccess(self, 'Jobs refreshed successfully')
  } else {
    notifyError(self, 'Failed to refresh Jobs')
  }
}

export async function jobValidateContactEmails(self, statePath) {
  const job = self.$store.get(`${createOrEdit(statePath)}`)

  let clientContact = null
  let builderContact = null

  let noClientEmail = false
  let noBuilderEmail = false

  if (job.clientId && job.clientContactId){
    const clientResponse = await self.$store.dispatch('fetchById', {
      endpoint: Constants.ENTITY_ENDPOINTS.COMPANIES,
      id: job.clientId
    })

    if (OK === clientResponse.status && clientResponse.data.contacts.length > 0) {
      clientContact = objectBy(clientResponse.data.contacts, 'id', job.clientContactId)
      if (!clientContact.emails || clientContact.emails.length === 0) {
        noClientEmail = true
      }
    }
  }

  if (job.builderId && job.builderContactId){
    const builderResponse = await self.$store.dispatch('fetchById', {
      endpoint: Constants.ENTITY_ENDPOINTS.COMPANIES,
      id: job.builderId
    })

    if (OK === builderResponse.status && builderResponse.data.contacts.length > 0) {
      builderContact = objectBy(builderResponse.data.contacts, 'id', job.builderContactId)
      if (!builderContact.emails || builderContact.emails.length === 0) {
        noBuilderEmail = true
      }
    }
  }

  if (noClientEmail || noBuilderEmail) {
    const payload = {
      builderContact: noBuilderEmail ? builderContact : null,
      clientContact: noClientEmail ? clientContact : null
    }
    self.$eventHub.$emit('show-modal-2', 'No Contact Email', payload, '600px')
    return
  }

  await self.validateJobDetailsAndSubmit()
}

export async function jobCheckClientAndPoRequiredAndSave(self, statePath) {
  const job = self.$store.get(`${createOrEdit(statePath)}`)

  if (!job.clientId) {
    self.$eventHub.$emit('show-modal-2', 'No Client Selected', null, '450px')
    return
  }

  const response = await self.$store.dispatch('fetchById', {
    endpoint: Constants.ENTITY_ENDPOINTS.COMPANIES,
    id: job.clientId
  })

  if (OK === response.status && response.data.poRequired && !self.purchaseOrderNumber) {
    self.$eventHub.$emit('show-modal-2', 'Client Requires PO', response.data.name, '450px')
    return
  }

  await self.validateContactEmails()
}
